export const DotLoader = () => {
  return (
    <div className="flex gap-3 pb-2">
      <div
        className=" w-5 h-5 rounded-full bg-primary-200 animate-jumping"
        style={{ animationDelay: '0.1s' }}
      ></div>
      <div
        className=" w-5 h-5 rounded-full bg-primary-200 animate-jumping"
        style={{ animationDelay: '0.2s' }}
      ></div>
      <div
        className=" w-5 h-5 rounded-full bg-primary-200 animate-jumping"
        style={{ animationDelay: '0.3s' }}
      ></div>
    </div>
  );
};
